module.exports = __webpack_public_path__ + "img/menu-bg.0a81617f.svg";